// Could be youtube.com, youtu.be, etc.
export const isValidVideoUrl = (url: string): boolean => !!url.match(/^.*y.?o.?u.?t.?u.?b.?e.*$/i);
